<template>
  <div>
    <nav class="child_nav">
      <ul>
        <li v-for="(nav,index) in navs" :key="index" :class="{'active': nav.active}" >
          <a v-if="nav.isChild"  @click=goTo(nav)>{{ nav.title }}</a>
        </li>
      </ul>
      <!--因这块操作按钮不一样，所以单独写页面-->
      <div class="right">
        <span class="batch" @click="batch" v-if="!showBatch">批量操作</span>
        <div v-else>
          <span class="batch" @click="selectAll">全选</span>
          <span class="batch" @click="batchDel" >删除</span>
          <span class="cancel" @click="cancel" >取消</span>
        </div>

        <span class="add" @click="add">添加好友</span>
      </div>
    </nav>
    <div class="child_main">
        <div class="content">
            <div class="unit" 
            v-if="pageProps.records.length>0"
            v-for="(item,index) in pageProps.records" :key="index" >
            <el-checkbox fill="#fd4340" v-show="showBatch" @change="changeChecked" v-model="item.checked" class="checkbox"></el-checkbox>

              <img class="avatar" :src="item.user_avatar"/>
              <div class="uinfo">
                  <p>{{ item.friend_user_name }}</p>
                  <div>
                    <span  class="home_btn" @click="goHome(item.friend_user_app_id)">查看主页</span>
                    <span  class="chat_btn">去聊呗</span>
                  </div>
              </div>
            </div>
            <el-empty description="暂无数据" v-else></el-empty>
        </div>

        <el-empty description="暂无数据"  v-if="pageProps.records.length<=0"></el-empty>


        <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          :hide-on-single-page="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[6, 12, 60, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <friend-add-dialog ref="friendDialog" @refresh="fetchData"></friend-add-dialog>

  </div>
</template>
<script>
import friendAddDialog from "@/views/relation/friend/friend-add-dialog.vue";

import {friendListApi,friendDelApi} from "@/api/relation/index.js";
export default {

  name: 'friend-index',
  components: { friendAddDialog},

  data () {
    return {
      showBatch:false,
      navs: [
        {
          title: "我的好友",
          name: 'relation-friend-index',
          path: '/relation-friend-index',
          isChild: 1,
          num: 0,
          active: true
        },
        {
          title: "关注我的",
          name: 'relation-friend-fans',
          path: '/relation-friend-fans',
          isChild: 1,
          num: 0,
          active: false
        },
        {
          title: "我的关注",
          name: 'relation-friend-follow', // 
          path: '/relation-friend-follow',
          isChild: 1,
          num: 0,
          active: false
        },
      
      ],

      searchLoading: false,
        pageProps: {
          records:[],
          total: 0,
          pageSize: 12,
          pageNum: 1
        },

        searchFormData:{
          keyword:"",
          page:0,
          limit:0
        }
    }
  },
  created () {
    console.log(this.$route.name);
    this.fetchData();

  },
  methods: {
    goTo (nav) {
      this.$router.push({ name: nav.name});
      //let routeData = this.$router.resolve({ name: nav.name, });
     // window.open(routeData.href, '_blank');

    },

    goHome(user_app_id){
      this.$goUserHome(user_app_id);

    },

    add(){
        this.$refs.friendDialog.init();
      },

    batch(){
      console.log("batch")
      this.showBatch=true;
    },

    cancel(){
      console.log("cancel")
      this.showBatch=false;
    },
    selectAll(){
      this.pageProps.records.forEach((item) => {
        item.checked = true
      });
    },

    batchDel(){
      var that = this;

      var selected=[];
      this.pageProps.records.forEach((item) => {
        if(item.checked == true){
          selected.push(item.friend_user_app_id);
        }
      });
      if(selected.length<=0){
        that.$message.error("请选择数据");
        return;
      }



      friendDelApi({user_app_ids:selected}).then((response) => {
        console.log(response);
        if(response.code==200){
          that.fetchData();
        }else{
          that.$message.error(response.msg?response.msg:"请求错误");
        }
        
      });



    },
    //单个选中
    changeChecked (e,idx) {
      console.log(e)
      this.pageProps.records.forEach((item,index) => {
        if(index==idx){
          item.checked =e;
        }
      });

    },



     // 当前页变更
     handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },

      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },

      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        friendListApi(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },


  }
}
</script>

<style lang="scss" scoped>
.child_nav {
  height: 50px;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 10px;
    background: #f1f1f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  ul {
    display: flex;
    height: 100%;
    align-items: center;
    margin: 0px 20px;

    li {
      position: relative;
      &.active{
          border-bottom: 2px solid #4c71db;
          color:#4c71db ;
          font-weight: bold;

          a{
            color:#4c71db ;
            font-weight: bold;
          }
        }
      a {
        cursor: pointer;
        padding: 0 24px;
        display: block;
        font-size: 16px;
        &.router-link-active {
          //background-color: #4c71db;
          border-bottom: 1px solid #4c71db;
          color:#4c71db ;
          font-weight: bold;
          //color: #fff;
        }
      
      }
      aside {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        background-color: #ff4e4e;
        border-radius: 10px;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
      }
    }
  }

  .right{
    display: flex;

    span{
      margin: 0px 10px;
      padding: 5px;
      border-radius: 3px;
      font-size: 12px;
      cursor: pointer;
    }

    .batch{
      color:#4C71DB;

    }

    .cancel{
      color:#878788;

    }

    .add{
      background: #4C71DB;
      color: #ffffff;

    }

  }
}
.child_main {
  border-radius: 6px;
  background: #FBFBFB;

  .content{
    display: flex;
    flex-wrap: wrap;
    
    .unit{
      width: 28%;
      max-width: 28%;
      min-width: 28%;
      margin: 10px;
      padding: 10px;
      border-radius: 10px;
      background: #ffffff;
      display: flex;
      font-size: 14px;
      position: relative;

      .checkbox{
        position: absolute;
        right: 10px;
        top: 10px;
      }

      &:hover{
        box-shadow: 0px 0px 6px rgba(0,0,0,0.16);
      }

      .avatar{
        width:86px;height: 86px;
        border-radius: 10px;
      }

      .uinfo{
        flex:1;display:flex;justify-content: space-around;flex-direction:column;padding:0px 10px;

        div{
          display: flex;justify-content: space-between;

          .chat_btn{
            cursor: pointer;
            padding: 5px 10px;
            background-color: #4C71DB;color: #ffffff;
            border-radius: 5px;
          }
          .home_btn{
            cursor: pointer;
            padding: 5px 10px;
            color: #4C71DB;
          }
        }
      }


      .info{
        display:flex;justify-content: space-around
      }
    }

  }
  
}
</style>